import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'
import { PHYSICAL_STORE_FRAGMENT } from './PhysicalStoreFragment'

export const DRAW_MAP_TASK_FRAGMENT = gql`
  fragment DrawMapTask on IndoorMapDrawTask {
    id
    needsScan
    scannerPaidOn
    scanVerifiedOn
    store {
      ...PhysicalStore
    }
    mapper {
      ...User
    }
    scanner {
      ...User
    }
    storeAreas {
      id
      name
      defaultForStoreSize
    }
    daiEmployeeVerifier {
      ...User
    }
    mapUploadedOn
    scannerVerifiedOn
    daiEmployeeVerifiedOn
    scanBucketFilePath
    faroBucketFilePath
    pdfBucketFilePath
    comments {
      comment
      id
      user {
        ...User
      }
    }
  }
  ${USER_FRAGMENT}
  ${PHYSICAL_STORE_FRAGMENT}
`
